/** 任务大类下拉（与字典 rd_task_type.remark / 后端分组码一致） */
export type TaskBigTypeOption = { label: string; value: string };

export const TASK_BIG_TYPE_OPTIONS: TaskBigTypeOption[] = [
  { label: 'UI任务', value: 'UI_TASK' },
  { label: '产品任务', value: 'PRODUCT_TASK' },
  { label: '前端任务', value: 'FRONT_TASK' },
  { label: '后端任务', value: 'BACK_TASK' },
  { label: '测试任务', value: 'TEST_TASK' },
  { label: '运维任务', value: 'OPERATION_TASK' },
  { label: '其他类任务', value: 'OTHER_TASK' },
];
